import { Component, ReactNode } from 'react';



interface ErrorBoundaryProps {
	children: ReactNode
}

interface ErrorBoundaryState {
	hasError: boolean,
	errorMessage: string | undefined,
	errorStack: string | undefined
}


class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
	constructor(props: ErrorBoundaryProps) {
		super(props);
		this.state = {
			hasError: false,
			errorMessage: undefined,
			errorStack: undefined
		};
	}

	static getDerivedStateFromError(error: Error) {
		// Update state so the next render will show the fallback UI. 
		return { hasError: true, errorMessage: error.message, errorStack: error.stack };
	}

	componentDidCatch(error: Error, errorInfo: any) {
		// You can also log the error to an error reporting service
		console.error('Error boundary app', errorInfo, error);
	}

	render() {
		if (this.state.hasError) {
			return (
				<div className='components-error-boundary'>
					<h1>Něco se pokazilo</h1>

					<p className='error-label'>Prosím znovu načtěte stránku</p>
				</div>
			);
		};
		return this.props.children;
	}
}

export default ErrorBoundary;